<form [formGroup]="formGroup" *ngIf="this.currentStepper == this.stepperIndex">
    <app-simyo-rates [index]="index" [showTypeContent]="orderType.MOBILE" (requestRemovePostpaidsLines)="doRemoveAllAdditionalPostpaids($event)" *ngIf="rate == null"></app-simyo-rates>

    <div *ngIf="rate">
        <div class="container content">
            <div class="row" style="gap: 30px;" >
                <!-- TODO: Poner condición para mostrar solo cuando sea móvil y una sola tarifa -->
                <div class="col-xl-12" *ngIf="!getShowChangeFirstLine() && simyoService.isShowSimyoTVBono()">
                    <div class="row d-flex align-items-center m-0 additional-services-header">
                        <h6 class="fw-bold m-0 p-0">Servicios adicionales</h6>
                    </div>
                    <div class="row m-0 additional-services-content">
                        <div class="col-12 additional-services-content-inner">
                            <div class="row d-flex align-items-center m-0" [formGroup]="formGroup" style="column-gap: 45px;">
                                <div class="col-auto p-0">
                                    <h6 class="fw-bold m-0 p-0">
                                        Añadir  <span class="text-simyo">TV</span>
                                    </h6>
                                </div>
                                <div class="col m-0 p-0 radio-btn-group toggle-simyo-tv justify-content-end" style="gap: 24px;">
                                    <ng-container *ngFor="let plan of simyoTVPlans">
                                        <div class="d-flex align-items-center" style="gap: 8px;">
                                            <span class="text-simyo fw-bold">{{ bonoSimyoTVName(plan.product_code) }}</span>
                                            <mat-slide-toggle
                                                class="p-0"
                                                hideIcon="true"
                                                [checked]="formGroup.get('simyoTVProductCode')?.value === plan.product_code"
                                                (change)="changeSimyoTVPlan(plan.product_code, $event.checked)">
                                            </mat-slide-toggle>
                                            <span
                                                class="toggle-simyo-tv-price m-0 p-0" 
                                                [class.toggle-simyo-tv-price--active]="formGroup.get('simyoTVProductCode')?.value === plan.product_code">
                                                + {{ formatSimyoTVPrice(plan.price) }} €
                                            </span>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" style="gap: 30px; display: flex; flex-direction: column;">
                    <h5 class="title-step m-0 text-center" >
                        <img src="./assets/img/package.svg" class="img-fluid ico-title" width="20">
                        {{ 'Tarifa ' + (index + 1) + 'ª línea móvil' }}
                    </h5>
                    <div class="card card-default card-horizontal mb-4">
                        <div class="card-heading">
                            <div class="row m-0 p-3">
                                <div class="col-lg p-0 align-self-center">
                                    <h5  class="tar-name car-tar-1 m-0 pe-3">
                                        <!--{{ (rateFtth !== null && index === 0) ? ((fiberIndirectTechnologies.includes(order?.broadband?.access_type) ? 'FIBRA IND ' : 'FIBRA ') + rateFtth?.name + ' + ') : '' }}-->
                                         {{ rate?.data + ' + ' + rate?.voice }} <!--{{ rate && rate.bonos && rate.bonos.length ? ' + ' + rate.bonos.length + ' bono(s)' : '' }}-->
                                    </h5>
                                </div>
                                <div class="col-lg-auto p-0 align-self-center">
                                    <h5  class="tar-price car-tar-2 m-0">
                                        <!-- descuento para primera línea de convergente -->
                                        <ng-container *ngIf="true || (rateFtth === null || index > 0)">
                                            <!-- {{ +rate?.rate_info?.real_price + priceBonos|toFixedDecimals }} -->
                                            {{ +rate?.rate_info?.real_price|toFixedDecimals }}
                                            <span>€/mes</span>
                                        </ng-container>
                                        <!--<ng-container *ngIf="rateFtth && index === 0">
                                            {{ ++getPriceBySpeed(rateFtth?.rate_info?.speed) + priceBonos|toFixedDecimals }}
                                            <span>€/mes</span>
                                        </ng-container>-->
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-body" style="vertical-align: middle;">
                            <!--<div class="row" *ngIf="rateFtth && index === 0">
                                <div class="col-md-5 d-flex flex-column justify-content-center">
                                    <h5  class="tar-name-5 my-0" *ngIf="rateFtth.name">
                                        <b>{{ (fiberIndirectTechnologies.includes(order?.broadband?.access_type) ? 'Fibra IND ' : 'Fibra ') + rateFtth.name }}</b>
                                    </h5>
                                    <h5  class="tar-name-5 my-0">
                                        <b>INSTALACIÓN GRATIS</b>
                                    </h5>
                                    <h5  class="tar-name-5 my-0">
                                        <b>ROUTER EN CESIÓN GRATIS</b>
                                    </h5>
                                </div>
                                <div class="col-md-auto"><span class="vl mobile"></span></div>
                                <div class="col-md-5 d-flex flex-column justify-content-center">
                                    <h5  class="tar-name-5 my-0" *ngIf="rate && rate.data">
                                        {{ rate?.data }}
                                    </h5>
                                    <h5  class="tar-name-5 my-0" *ngIf="rate && rate.voice">
                                        {{ rate?.voice }}
                                    </h5>
                                    <ng-container *ngIf="rate && rate.bonos && rate.bonos.length">
                                        <h5  class="tar-name-5 my-0" *ngFor="let bono of rate.bonos">
                                            {{ bono.rate_info.description }}
                                        </h5>
                                    </ng-container>
                                </div>
                                <div class="col-md-1 btn-change align-self-center">
                                    <a class="btn btn-simyo-a btn-sm color-white" (click)="changeRate()">Cambiar</a>
                                </div>
                            </div>-->

                            <!-- Solo movil -->
                            <div class="row d-flex w-100 mx-0" *ngIf="true || (!rateFtth || index !== 0)" style="gap: 20px;">
                                <div class="p-0 col-md align-self-center">
                                    <h5  class="tar-name-5 m-0" *ngIf="rate && rate.data">
                                        <b>{{ rate?.data }}</b> de navegación
                                    </h5>
                                </div>
                                <div class="p-0 col-md-auto"><span class="vl mobile"></span></div>
                                <div class="p-0 col-md-5 align-self-center">
                                    <h5  class="tar-name-5 m-0" *ngIf="rate && rate.voice">
                                        {{ rate?.voice }}
                                    </h5>
                                    <!-- <ng-container *ngIf="rate && rate.bonos && rate.bonos.length">
                                        <h5  class="tar-name-5 my-0" *ngFor="let bono of rate.bonos">
                                            {{ bono.rate_info.description }}
                                        </h5>
                                    </ng-container> -->
                                </div>
                                <div class="p-0 m-0 col-md-auto btn-change align-self-center" *ngIf="(typeOrder == 'broadband' || getShowChangeFirstLine())">
                                    <a class="btn btn-simyo-a btn-sm color-white" (click)="changeRate()">Cambiar</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container content">
            <div class="row mt-4">
                <div class="col-lg-12">
                    <h5 class="title-step text-center" >
                        <img src="./assets/img/smartphone.svg" class="img-fluid ico-title" width="20"> Tipo de operación línea móvil
                    </h5>
                    <div class="card">
                        <div class="card-header pt-3 pb-3">
                            <div class="d-flex justify-content-between align-items-center">

                                <!----- Tipo de operación ------->
                                <div class="radio-btn-group" [formGroup]="formGroup">
                                    <h6 class="subtitulo-pack">Tipo de operación: </h6>
                                    <div class="radio" *ngIf="showWithPortability('digi')">
                                        <input id="btnRegister" type="radio" name="type_operation" value="registration" formControlName="type_operation" (change)="changeTypeOperation($event.currentTarget.value)">
                                        <label for="btnRegister" class="radio-width" class="rounded-0">
                                            Alta nueva 
                                        </label>
                                    </div>
                                    <div class="radio">
                                        <input id="btnPorta" type="radio" name="type_operation" value="portability" formControlName="type_operation" (change)="changeTypeOperation($event.currentTarget.value)">
                                        <label for="btnPorta" class="radio-width" class="rounded-0">
                                            Portabilidad
                                        </label>
                                    </div>
                                    <div class="radio" *ngIf="permSv.hasPermFromV2(allPermissions.simyo.permite_portabilidad_con_cambio_de_titular) && isCustomerNotCif">
                                        <input id="btnPortaChange" type="radio" name="type_operation" value="portability_change" formControlName="type_operation" (change)="changeTypeOperation($event.currentTarget.value)" [attr.disabled]="!checkIfFirstPortaChange() ? true : null">
                                        <label for="btnPortaChange" class="radio-width" class="rounded-0" [ngClass]="{'label-tooltip': !checkIfFirstPortaChange()}" [ngStyle]="{ 'cursor': checkIfFirstPortaChange() ? 'pointer' : 'context-menu' }">
                                            Portabilidad con cambio de titular 
                                            <span *ngIf="!checkIfFirstPortaChange()" class="btn-tooltip" title="Ya hay una portabilidad con cambio de titular en esta solicitud, si necesitas más portabilidades con cambio de titular, debes tramitarlo en una nueva solicitud.">
                                                <img [src]="typeOperation == 'portability_change' ? './assets/img/info-white.svg' : './assets/img/info.svg'" class="img-fluid ico-title icon-white" width="16" >
                                            </span>
                                        </label>
                                    </div>
                                </div>  

                                <small class="text-muted">
                                    <!----- Fecha estimada si es portabilidad / si es alta no aparece nada------->
                                    <!--<h6 class="subtitulo-pack fecha">Fecha estimada de portabilidad: <span class="verde"><b>04/04</b></span></h6>-->
                                </small>
                            </div>
                            <mat-error class="error" *ngIf="showErrorTypeOperation">
                                Campo obligatorio
                            </mat-error>
                        </div>
                        <ul class="list-group list-group-flush" *ngIf="typeOperation !== ''">
                            <li class="list-group-item cuerpo-pack pt-4 pb-3">
                               
                                <div class="radio-btn-group" [formGroup]="formGroup" *ngIf="permSv.hasPermFromV2(allPermissions.simyo.permite_sell_esim)" (change)="changeTypeCard()">
                                    <h6 class="subtitulo-pack">Tipo de tarjeta: </h6>
                                    <div class="radio">
                                        <input id="btnSim" type="radio" name="is_esim" [value]="typeCard.sim" formControlName="is_esim">
                                        <label for="btnSim" class="rounded-0">
                                            SIM física
                                        </label>
                                    </div>

                                    <div class="radio">
                                        <input id="btnEsim" type="radio" name="is_esim" [value]="typeCard.esim" formControlName="is_esim" (click)="showMessage()">
                                        <label for="btnEsim" class="rounded-0">
                                            eSIM
                                        </label>
                                    </div>
                                </div>

                                <h6 class="subtitulo-pack-form" *ngIf="typeOperation === 'portability' || typeOperation === 'portability_change'">
                                    Datos de alta / portabilidad
                                </h6>
                                <div class="row" *ngIf="typeOperation === 'portability' || typeOperation === 'portability_change'" style="row-gap: 24px;">
                                    <div class="col-lg-3 mb-0 mt-1">
                                       <!--  <mat-form-field>
                                            <mat-label>Teléfono móvil a portar</mat-label>
                                            <input type="text" matInput formControlName="portability_phone" maxlength="9" (keypress)="numberOnly($event)">
                                        </mat-form-field>
                                        <mat-error class="err-field" *ngIf="formGroup.get('portability_phone')?.errors?.notmustMatch && formGroup.get('portability_phone')?.touched">
                                            Número de teléfono a portar ya utilizado en este flujo
                                        </mat-error> -->
                                        <digo-input
                                            id="portability_phone"
                                            label="Teléfono móvil a portar"
                                            [formGroup]="formGroup"
                                            controlName="portability_phone"
                                            [maxlength]="9"
                                            type="text"
                                            (keypress)="numberOnly($event)"
                                            [isRequired]="isControlRequired('portability_phone')"
                                        />
                                        <!-- <mat-error *ngIf="formGroup.get('portability_phone')?.errors?.notmustMatch">
                                            <span style="font-size: 12px;">Número de teléfono a portar ya utilizado en este flujo</span>
                                        </mat-error> -->
                                    </div>
                                    <div class="col-lg-3 mt-1">
                                        <!-- <mat-form-field>
                                            <mat-label>Operador donante</mat-label>
                                            <select matNativeControl formControlName="portability_operator">
                                                <option *ngFor="let provider of serviceProviders" [ngValue]="provider.service_provider_id">
                                                    {{ provider.value }}
                                                </option>
                                            </select>
                                        </mat-form-field> -->
                                        <digo-select
                                            [label]="'Operador donante'"
                                            [options]="serviceProviders" 
                                            [formGroup]="formGroup"
                                            controlName="portability_operator"
                                            optionValue="service_provider_id"
                                            optionLabel="value"
                                            [isRequired]="isControlRequired('portability_operator')"
                                            [isDisabled]="portabilityOperatorDisabled"
                                        />
                                    </div>
                                    <div class="col-lg-3 mt-1">
                                        <!-- <mat-form-field>
                                            <mat-label>Tipo de cliente donante</mat-label>
                                            <select matNativeControl formControlName="portability_type_client"
                                                    (change)="changePortabilityTypeClient($event.target.value)">
                                                <option [value]="'postpaid'" [selected]="portabilityTypeClient === 'postpaid'">Contrato</option>
                                                <option [value]="'prepaid'" [selected]="portabilityTypeClient === 'prepaid'">Prepago</option>
                                            </select>
                                        </mat-form-field> -->
                                        <digo-select
                                            [label]="'Tipo de cliente donante'"
                                            [options]="portability_types" 
                                            [formGroup]="formGroup"
                                            controlName="portability_type_client"
                                            optionValue="portability_type_id"
                                            optionLabel="value"
                                            (OnChange)="changePortabilityTypeClient($event.target.value)"
                                            [isRequired]="isControlRequired('portability_type_client')"
                                        />
                                    </div>
                                    <div class="col-lg-3 mb-0 mt-1" *ngIf="portabilityTypeClient === 'prepaid'" style="position: relative;">
                                       <!--  <mat-form-field class="col-11">
                                            <mat-label>ICCID donante</mat-label>
                                            <input type="text" matInput formControlName="portability_iccid" maxlength="19" minlength="19">
                                            <mat-hint class="text-end">{{ formGroup.get('portability_iccid').value.length }} / 19</mat-hint>
                                        </mat-form-field> -->
                                        <!-- <div class="d-flex align-items-center position-relative">
                                            <div class="w-100 position-relative"> -->
                                                <digo-input
                                                    id="iccid_portability"
                                                    class="w-100 pe-5 iccid_porta"  
                                                    label="ICCID donante"
                                                    [formGroup]="formGroup"
                                                    controlName="portability_iccid"
                                                    [maxlength]="19"
                                                    [minlength]="19"
                                                    type="text"
                                                    [isRequired]="isControlRequired('portability_iccid')"
                                                    (OnKeyDown)="onlyPositiveDigits($event)"
                                                    (paste)="validatePasteIccid($event)"
                                                />
                                            <!-- </div> -->
                                            <mat-hint class="iccid-hint" style="margin-top: -16px;">{{ formGroup.get('portability_iccid').value?.length }} / 19</mat-hint>
                                        <!-- </div> -->
                                       <!--  <mat-error *ngIf="formGroup.get('portability_iccid')?.errors?.notmustMatch">
                                            ICCID ya utilizado en este flujo
                                        </mat-error> -->
                                    </div>
                                </div>

                                <h6 class="subtitulo-pack-form" *ngIf="typeOperation !== '' && formGroup.get('is_esim').value == typeCard.sim">
                                    Datos SIM en Simyo
                                </h6>
                                <div class="row" *ngIf="typeOperation !== '' && formGroup.get('is_esim').value == typeCard.sim">
                                    <!-- <div class="col-lg-5 mb-0">
                                        <mat-form-field class="col-11">
                                            <mat-label>ICCID entregado al cliente</mat-label>
                                            <input type="text" matInput formControlName="iccid" (change)="isValidIccid('iccid')" (input)="isValidIccid('iccid')" [maxlength]="lengthICCID" [minlength]="lengthICCID">
                                            <span *ngIf="iccidLoading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                            <mat-hint class="text-end">{{ formGroup.get('iccid').value?.length }} / 19</mat-hint>
                                        </mat-form-field>
                                        <a class="cursor-pointer" (click)="openModalICCID(ICCID)" title="¿Dónde encuentro el ICCID?">
                                            <img src="./assets/img/info.svg" class="img-fluid ico-title icon-white" width="20">
                                        </a>
                                        <mat-error class="err-iccid" *ngIf="formGroup.get('iccid')?.errors?.notmustMatch && formGroup.get('iccid')?.touched">
                                            ICCID ya utilizado en este flujo
                                        </mat-error>
                                        <mat-error class="err-iccid" *ngIf="formGroup.get('iccid')?.errors?.used && formGroup.get('iccid')?.touched">
                                            ICCID en uso, utiliza otra sim
                                        </mat-error>
                                        <mat-error class="err-iccid" *ngIf="formGroup.get('iccid')?.errors?.invalid && formGroup.get('iccid')?.touched">
                                            ICCID no es válido
                                        </mat-error>
                                    </div> -->
                                    <div class="col-lg-5 mb-0">
                                        <div class="d-flex align-items-center position-relative">
                                            <div class="w-100 position-relative mt-3">
                                                <digo-input
                                                    id="iccid_client"
                                                    class="w-100 pe-5"  
                                                    label="ICCID entregado al cliente"
                                                    [formGroup]="formGroup"
                                                    controlName="iccid"
                                                    [maxlength]="19"
                                                    [minlength]="19"
                                                    type="text"
                                                    (input)="isValidIccid('iccid')"
                                                    [isRequired]="isControlRequired('iccid')"
                                                    (OnKeyDown)="onlyPositiveDigits($event)"
                                                    (paste)="validatePasteIccid($event)"
                                                />
                                                <span *ngIf="iccidLoading" class="spinner-grow spinner-grow-sm position-absolute end-0" style="top: 25%;" role="status" aria-hidden="true"></span>
                                            </div>
                                
                                            <a class="cursor-pointer" (click)="openModalICCID(ICCID)" title="¿Dónde encuentro el ICCID?" style="position: relative; top: -2px;">
                                                <img src="./assets/img/info.svg" class="img-fluid icon-white" width="20" style="margin-top: -15px;">
                                            </a>
                                            <mat-hint class="iccid-hint">{{ formGroup.get('iccid').value?.length }} / 19</mat-hint>
                                        </div>
                                       <!--  <mat-error *ngIf="formGroup.get('iccid')?.errors?.notmustMatch" style="margin-top:-25px">
                                            ICCID ya utilizado en este flujo
                                        </mat-error>
                                        <mat-error *ngIf="formGroup.get('iccid')?.errors?.used" style="font-size: 0.8rem; margin-top: -43px;position: absolute;">
                                            ICCID en uso, utiliza otra sim
                                        </mat-error> -->
                                          <!--
                                        <mat-error *ngIf="formGroup.get('iccid')?.errors?.invalid">
                                            ICCID no es válido
                                        </mat-error> -->
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Terminal -->
            <div class="row mt-5" *ngIf="permSv.hasPermFromV2(allPermissions.simyo.permite_venta_terminales) && typeOperation !== ''">
                <div class="col-lg-12">
                    <h5 class="title-step text-center" >
                        <img src="./assets/img/smartphone.svg" class="img-fluid ico-title" width="20"> Selección de terminal
                    </h5>
                    <div class="card">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item cuerpo-pack">
                                <div class="row">
                                    <div class="col-lg-7 mb-0">
                                        <div *ngIf="!environment.showSimyoTerminals">Upss, nos encontramos realizando tareas de mantenimiento. Perdón por las molestias.</div>
                                        <app-simyo-terminal *ngIf="environment.showSimyoTerminals" [index]="index" [formGroup]="formGroup" #terminalCmp></app-simyo-terminal>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- bloque línea adicional -->
             <div class="card">
                <div class="card-header mt-4 pt-3 pb-3" *ngIf="allowAddAdditionalLines">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <span class="ad-text">¿Deseas añadir <b>una línea de móvil adicional</b>?</span>
                        </div>
                        <div class="text-muted">
                            <a (click)="addMobileLine()" class="btn btn-black btn-sm text-white fw-bold fs-6 pt-2 pb-2 ps-3 pe-3" role="button" style="line-height: 24px;">
                              Contratar <span class="mobile">línea de móvil adicional</span>
                            </a>
                          </div>
                    </div>
                </div>
             </div>
             

            <!-- Continuar proceso -->
            <div class="mt-4 d-flex flex-column gap-2 w-100 mb-5">
                <a (click)="next()" class="btn btn-simyo-o2 w-100 color-white" role="button">
                    Continuar <img src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15">
                </a>
                <a (click)="prev()" class="btn btn-simyo-o w-100" role="button" *ngIf="!(typeOrder === 'mobile' && index === 0)">
                    Volver
                </a>
            </div>
        </div>
    </div>
</form>

<ng-template #ICCID let-modal>
    <div class="modal-header bg-simyo-grey">
        <h5 class="modal-title white" id="exampleModalLabel">¿Dónde encuentro el ICCID?</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
        </button>
    </div>
    <img src="./assets/img/iccid-simyo.png" class="img-fluid ico-title p-5">
</ng-template>

<ng-template #esimNotAvailable let-modal>
    <div class="modal-header" style="background-color: #fff;">
        <b class="col text-simyo pe-0 mt-2 text-center" style="font-size: 18px;" >IMPORTANTE</b>
    </div>

    <div class="modal-body pt-0" id="bodyModal">
        <div class="m-3 row">
            <span class="col-12 text-center" >
                Upssss servicio no disponible hasta nuevo aviso. Disculpa las molestias.
            </span>
        </div>
        <a (click)="modal.dismiss('Cross click')" class="btn btn-simyo-o2 d-block w-100 mb-1" role="button">
            Entendido
        </a>
    </div>
</ng-template>